module.exports = __webpack_public_path__ + "img/bg_avatar_male_73.ce1f2cb5.png";